module.exports = __webpack_public_path__ + "img/newLogo.4656d430.png";